/**
 * Caries — irregular brown-black lesion(s) with organic edges and a soft halo.
 * If no surfaces are selected we default to an occlusal lesion.
 */
import { SURFACE_POS, uid } from "./_shared";

export default function Caries({ surfaces = [], toothId }) {
  const spots = (surfaces.length ? surfaces : ["O"]).filter((s) => SURFACE_POS[s]);
  const gid = uid("caries", toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <radialGradient id={gid} cx="45%" cy="45%" r="60%">
          <stop offset="0%"   stopColor="#0F0803" />
          <stop offset="45%"  stopColor="#4A2B15" />
          <stop offset="100%" stopColor="#7A4520" stopOpacity="0.55" />
        </radialGradient>
      </defs>
      {spots.map((s) => {
        const { cx, cy } = SURFACE_POS[s];
        return (
          <g key={s}>
            {/* Soft brown halo (demineralised zone) */}
            <ellipse cx={cx} cy={cy} rx={7.5} ry={6.5}
                     fill="#8B5A2B" fillOpacity={0.25} />
            {/* Main irregular lesion */}
            <path
              d={`M ${cx - 5.5} ${cy - 1.5}
                  Q ${cx - 4} ${cy - 5.5} ${cx - 0.5} ${cy - 4.8}
                  Q ${cx + 3.5} ${cy - 6} ${cx + 5.5} ${cy - 1}
                  Q ${cx + 6.5} ${cy + 2.8} ${cx + 2.5} ${cy + 5}
                  Q ${cx - 2.5} ${cy + 5.5} ${cx - 5.5} ${cy + 2.8}
                  Z`}
              fill={`url(#${gid})`}
              stroke="#2A180A"
              strokeWidth={0.4}
              strokeOpacity={0.9}
            />
            {/* Deep necrotic core */}
            <circle cx={cx - 0.6} cy={cy + 0.3} r={1.4} fill="#0A0402" />
            {/* Tiny satellite pit */}
            <circle cx={cx + 3}   cy={cy - 2}   r={0.6} fill="#0A0402" opacity={0.7} />
          </g>
        );
      })}
    </g>
  );
}
